export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";